import { Controller } from 'stimulus'

export default class extends Controller {
  closeVideo() {
    var videoPlayer = document.getElementById('video-player')
    videoPlayer.src = ''
    this.element.classList.toggle('modal-active')
  }
}
